import styled from 'styled-components';

export const TableRowStyled = styled.tr<{
  isSelected?: boolean;
  isClickable: boolean;
}>`
  background-color: ${(props) =>
    props.isSelected
      ? props.theme.atlas.semantic.color.surface.variant
      : props.theme.atlas.semantic.color.surface.default};
  width: 100%;
  height: 56px;
  &:hover {
    td:first-child {
      background-color: ${(props) =>
        props.isSelected
          ? props.theme.atlas.semantic.color.surface.variant
          : props.theme.atlas.semantic.color.surface.subtle};
    }
    background-color: ${(props) =>
      props.isSelected
        ? props.theme.atlas.semantic.color.surface.variant
        : props.theme.atlas.semantic.color.surface.subtle};
  }
  ${(props) => (props.isClickable ? 'cursor: pointer;' : '')}
`;
